<template>
  <div class="row">
    <div class="col-12">
      <card class="card-body">
        <template slot="header">
          <h1 class="card-title" style="font-size: 1.2em" v-html="$t('token.network')"> </h1>
        </template>
        <p style="font-size: 0.9em;">
          <a href="https://basescan.org/token/0x956bF3F50ddaa6dCE5fcE48AB62128Edb53DB27E"
             title="0x956bF3F50ddaa6dCE5fcE48AB62128Edb53DB27E"
             data-toggle="tooltip"
             target="_blank" rel="noopener" class="link footer-link d-text d-s">
            {{ $t("token.neio") }}
          </a>
        </p>

      <p style="font-size: 0.9em;">
        <a href="https://app.uniswap.org/swap?chain=base&inputCurrency=0x833589fcd6edb6e08f4c7c32d4f71b54bda02913&outputCurrency=0x956bF3F50ddaa6dCE5fcE48AB62128Edb53DB27E" target="_blank" rel="noopener" class="link footer-link d-text d-s">
          {{ $t("token.uniswap") }}
        </a>
      </p>
      </card>
    </div>

    <div class="col-12">
      <p style="font-size: 0.9em;">
        <a href="https://t.me/neionetwork" target="_blank" rel="noopener" class="link footer-link d-text d-s">
          {{ $t("telegram") }}
        </a>
      </p>

      <p style="font-size: 0.9em;">
        <a href="https://www.instagram.com/neio_network/" target="_blank" rel="noopener" class="link footer-link d-text d-s">
          {{ $t("instagram") }}
        </a>
      </p>
    </div>
    <div class="col-12">
      <card class="card-body">
        <template slot="header">
          <h1 class="card-title" style="font-size: 1.2em"> {{ $t("Create your exchange account") }} </h1>
        </template>
          <p style="font-size: 0.9em;">
            <a href="https://accounts.binance.com/register?ref=10902300" target="black" class="link footer-link d-text d-s">
              {{ $t("login.createBinanceAccount", { exchange: "Binance" }) }}
            </a>
          </p>
          <p style="font-size: 0.9em;">
            <a href="https://www.kucoin.com/r/rf/QBS4KLEF" target="black" class="link footer-link d-text d-s">
              {{ $t("login.createBinanceAccount", { exchange: "Kucoin" }) }}
            </a>
          </p>
          <p style="font-size: 0.9em;">
            <a href="https://www.okx.com/pt-br/join/2837578" target="black" class="link footer-link d-text d-s">
              {{ $t("login.createBinanceAccount", { exchange: "Okex" }) }}
            </a>
          </p>
      </card>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
    };
  }
};
</script>
<style></style>
